import { BusinessHours } from '@/components/business-hours/business-hours';
import CustomBreadcrumb from '@/components/custom-breadcrumb/custom-breadcrumb';
import { InitialMessage } from '@/components/initial-message/initial-message';
import { RedirectionTargets } from '@/components/redirection-targets/redirection-targets';
import { Tab } from '@/components/tab/tab';
import { useBreadcrumbs } from '@/hooks/use-breadcrumbs/use-breadcrumbs';
import { Flex } from 'antd';

export function Company() {
  const items = useBreadcrumbs();

  const tabItems = [
    {
      key: 'initial-mess',
      label: 'Initial message',
      children: <InitialMessage />,
    },
    {
      key: 'business-hours',
      label: 'Business hours',
      children: <BusinessHours />,
    },
    {
      key: 'redirection-targets',
      label: 'Redirection targets',
      children: <RedirectionTargets />,
    },
  ];

  return (
    <Flex vertical>
      <CustomBreadcrumb items={items} />
      <Tab items={tabItems} />
    </Flex>
  );
}
